// types

// classes
import { ContextMenuItem, ContextMenuType } from './context-menu';

//  --------------------------------------------------------------------------
//
//  R E D U X   S T A T E   M A N A G E M E N T
//
//  --------------------------------------------------------------------------

import { store } from '../../app/store';

// import state definition and functions.
import {
  CONTEXT_CONTAINERS,
  CONTAINER_IDS,
  CONTEXT_SYSTEMS,
  CONTEXT_SYSTEM_CONTAINERS,
  CONTEXT_MENU_WIDTH,
  CONTEXT_MENU_FILE_BROWSER,
  CONTEXT_MENU_SEARCH_CATALOG_FORM,
  CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS,
  CONTEXT_MENU_DATA_STAGING,
  CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM,
  CONTEXT_MENU_FILE_BROWSER_STAGING,
  NUM_CONTEXT_MENUS,
  ContextMenuState,
  ctx_setContextPos,
  ctx_setContextRow,
  ctx_setContextVisible,
} from './context-menu-slice';

import {
  buildContextMenu as buildContextMenuFileBrowser,
  buildContextMenuFileBrowserDataFiles,
  onContextMenuClick as onContextMenuClickFileBrowser,
  onContextMenuClickFileBrowserDataFiles,
} from '../data-management/file-browser-actions';

import {
  buildContextMenuAddMetadata as buildContextMenuSearchCatalogForm,
  buildContextMenuStageData as buildContextMenuSelectedItems,
  onContextMenuClickAddMetadata as onContextMenuClickSearchCatalogForm,
  onContextMenuClickStageData as onContextMenuClickSelectedItems,
} from '../search-catalog/search-catalog-actions';

import {
  buildContextMenuAddMetadata as buildContextMenuSearchCatalogFormCAOM,
  onContextMenuClickAddMetadata as onContextMenuClickSearchCatalogFormCAOM,
} from '../search-catalog-caom/search-catalog-caom-actions';

import {
  buildContextMenu as buildContextMenuProjectDataFiles,
  onContextMenuClick as onContextMenuClickProjectDataFiles,
} from '../project/project-actions';

//  --------------------------------------------------------------------------
//
//  T Y P E S
//
//  --------------------------------------------------------------------------

//  --------------------------------------------------------------------------
//
//  C O N S T A N T S
//
//  --------------------------------------------------------------------------

//  --------------------------------------------------------------------------
//
//  F U N C T I O N S
//
//  --------------------------------------------------------------------------

//  ------------------------------------------------------------
//
//  Call the appropriate function for building the context
//  menu, depending on what context system this is.
//
//  ------------------------------------------------------------

export function ctx_buildContextMenu(args: {
  contextSystem: CONTEXT_SYSTEMS;
  contextMenu: number;
  parentRowID: number;
}) {
  //
  // store the items so we can return them from the function.
  let items: ContextMenuItem[] = [];

  let menuName: string = '';
  switch (args.contextSystem) {
    //
    case CONTEXT_SYSTEMS.FILE_BROWSER:
      menuName = Object.keys(CONTEXT_MENU_FILE_BROWSER)[args.contextMenu];
      const menuFileBrowser: CONTEXT_MENU_FILE_BROWSER = Object.keys(
        CONTEXT_MENU_FILE_BROWSER,
      ).indexOf(menuName);
      items = buildContextMenuFileBrowser({
        menuID: menuFileBrowser,
        parentRowID: args.parentRowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.SEARCH_CATALOG_FORM:
      menuName = Object.keys(CONTEXT_MENU_SEARCH_CATALOG_FORM)[args.contextMenu];
      const menuSearchCatalogForm: CONTEXT_MENU_SEARCH_CATALOG_FORM = Object.keys(
        CONTEXT_MENU_SEARCH_CATALOG_FORM,
      ).indexOf(menuName);
      buildContextMenuSearchCatalogForm({
        menuID: menuSearchCatalogForm,
        parentRowID: args.parentRowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.SEARCH_CATALOG_SELECTED_ITEMS:
      menuName = Object.keys(CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS)[
        args.contextMenu
      ];
      const menuSearchSelectedItems: CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS =
        Object.keys(CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS).indexOf(menuName);
      items = buildContextMenuSelectedItems({
        menuID: menuSearchSelectedItems,
        parentRowID: args.parentRowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.PROJECT_DATA_FILES:
      menuName = Object.keys(CONTEXT_MENU_DATA_STAGING)[args.contextMenu];
      const menuProjectDataFiles: CONTEXT_MENU_DATA_STAGING = Object.keys(
        CONTEXT_MENU_DATA_STAGING,
      ).indexOf(menuName);
      buildContextMenuProjectDataFiles({
        menuID: menuProjectDataFiles,
        parentRowID: args.parentRowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.SEARCH_CATALOG_FORM_CAOM:
      menuName = Object.keys(CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM)[args.contextMenu];
      const menuSearchCatalogFormCAOM: CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM =
        Object.keys(CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM).indexOf(menuName);
      buildContextMenuSearchCatalogFormCAOM({
        menuID: menuSearchCatalogFormCAOM,
        parentRowID: args.parentRowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.FILE_BROWSER_STAGING:
      menuName = Object.keys(CONTEXT_MENU_FILE_BROWSER_STAGING)[args.contextMenu];
      const menuFileBrowserDataFiles: CONTEXT_MENU_FILE_BROWSER_STAGING = Object.keys(
        CONTEXT_MENU_FILE_BROWSER_STAGING,
      ).indexOf(menuName);
      buildContextMenuFileBrowserDataFiles({
        menuID: menuFileBrowserDataFiles,
        parentRowID: args.parentRowID,
      });
      break;
    //
  }

  // return the menu items.
  return items;
  //
} // ctx_buildContextMenu

//  ------------------------------------------------------------
//
//  Calculate the position for a menu, taking into account
//  the size of the container and the menu size.
//
//  ------------------------------------------------------------

export function ctx_calculatePosition(args: {
  contextSystem: CONTEXT_SYSTEMS;
  contextMenu: number;
  button?: string;
  pos?: {
    x: number;
    y: number;
  };
  parentMenu?: number;
  parentRowID?: number;
}) {
  //
  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  const stateFetch: any = store.getState();
  const state: ContextMenuState = stateFetch.contextMenu;

  // context menus.
  const sContextPos: {
    x: number;
    y: number;
  }[][] = state.contextPos;
  const sContextMenuDefinition: ContextMenuType[][] = state.contextMenuDefinition;

  // size of container.
  const sSize: {
    x: number;
    y: number;
  }[] = state.size;

  // scroll position.
  const sScrollPosition: number[] = state.scrollPosition;

  const CONTAINER: CONTEXT_CONTAINERS = CONTEXT_SYSTEM_CONTAINERS[args.contextSystem];
  const dataWindowWidth: number =
    CONTAINER !== CONTEXT_CONTAINERS.NONE ? sSize[CONTAINER].x : 0.0;
  const dataWindowHeight: number =
    CONTAINER !== CONTEXT_CONTAINERS.NONE ? sSize[CONTAINER].y : 0.0;
  const containerScrollPosition: number =
    CONTAINER !== CONTEXT_CONTAINERS.NONE ? sScrollPosition[CONTAINER] : 0.0;

  const childHeight: number =
    20 + sContextMenuDefinition[args.contextSystem][args.contextMenu].items.length * 30;

  //  --------------------------------------------------------------------------
  //
  //  F U N C T I O N   C O D E
  //
  //  --------------------------------------------------------------------------

  // get the size of the menu.
  const MENU_SIZE: {
    x: number;
    y: number;
  } = {
    x: CONTEXT_MENU_WIDTH[args.contextSystem],
    y: childHeight,
  };

  // get the position of the container.
  let containerPos: {
    x: number;
    y: number;
  } = {
    x: 0.0,
    y: 0.0,
  };
  const containerDiv: HTMLDivElement | null = document.querySelector(
    `#${CONTAINER_IDS[CONTAINER]}`,
  );
  if (containerDiv !== null) {
    //
    let bounds = containerDiv.getBoundingClientRect();
    containerPos = {
      x: bounds.left,
      y: bounds.top,
    };
    //
  }

  // if a button name is supplied, then get the left and right positions.
  // note that the bounds box will return the absolute position of a div element
  // on the page. we need to subtract the position of the container to find the
  // relative position.
  let posL:
    | {
        x: number;
        y: number;
      }
    | undefined = undefined;
  let posR:
    | {
        x: number;
        y: number;
      }
    | undefined = undefined;
  if (args.button !== undefined) {
    //
    const buttonDiv: HTMLInputElement | null = document.querySelector(`#${args.button}`);
    if (buttonDiv !== null) {
      //
      let bounds = buttonDiv.getBoundingClientRect();
      posL = {
        x: bounds.left - 5 - containerPos.x - MENU_SIZE.x,
        y: bounds.top - containerPos.y,
      };
      posR = {
        x: bounds.left + bounds.width + 5 - containerPos.x,
        y: bounds.top - containerPos.y,
      };
    }
    //
  }

  // if a parent menu and row were supplied, then get the left and right positions.
  if (args.parentMenu !== undefined && args.parentRowID !== undefined) {
    //
    posL = {
      x: sContextPos[args.contextSystem][args.parentMenu].x - MENU_SIZE.x,
      y: sContextPos[args.contextSystem][args.parentMenu].y + args.parentRowID * 30,
    };
    posR = {
      x: sContextPos[args.contextSystem][args.parentMenu].x + MENU_SIZE.x,
      y: sContextPos[args.contextSystem][args.parentMenu].y + args.parentRowID * 30,
    };
    //
  }

  // initialise the position. we can use the position supplied to the function,
  // or the position calculated relative to a button.
  let pos: {
    x: number;
    y: number;
  } = {
    x: 0.0,
    y: 0.0,
  };
  if (args.pos !== undefined) {
    pos = {
      x: args.pos.x - containerPos.x,
      y: args.pos.y - containerPos.y,
    };
  } else if (posR !== undefined) {
    pos = Object.assign({}, posR);
  }

  // check if the menu if off the right-hand side of the container.
  if (pos.x + MENU_SIZE.x > dataWindowWidth && dataWindowWidth > 0) {
    //
    // either switch the menu to the left-hand side (if a left-hand position is supplied),
    // or shift it to the left.
    if (posL !== undefined) {
      pos.x = posL.x;
    } else {
      pos.x = dataWindowWidth - MENU_SIZE.x;
    }
    //
  }

  // check if the menu if off the left-hand side of the container. If so,
  // move it, even if this means it's now off the right-hand side.
  if (pos.x < 0.0) {
    pos.x = 0.0;
  }

  // check if the menu is off the bottom of the container.
  // the window height gives the height of the visible part of the scrollable window,
  // but the y coordinate gives the position within the whole scrollable area.
  // we therefore need to include the container scroll position, which gives the position
  // of the top of the visible area within the whole scrollable area.
  if (
    pos.y + MENU_SIZE.y - containerScrollPosition > dataWindowHeight &&
    dataWindowHeight > 0
  ) {
    pos.y = dataWindowHeight - MENU_SIZE.y + containerScrollPosition;
  }

  // check if the menu if off the top of the container. If so,
  // move it, even if this means it's now off the bottom.
  if (pos.y < containerScrollPosition) {
    pos.y = containerScrollPosition;
  }

  // update the position of the child menu.
  store.dispatch(
    ctx_setContextPos({
      contextSystem: args.contextSystem,
      contextMenu: args.contextMenu,
      pos: pos,
    }),
  );
  //
} // ctx_calculatePosition

//  ------------------------------------------------------------
//
//  Call the appropriate function for building the context
//  menu, depending on what context system this is.
//
//  ------------------------------------------------------------

export function ctx_onContextMenuClick(args: {
  contextSystem: CONTEXT_SYSTEMS;
  contextMenuID: number;
  rowID: number[];
}) {
  //
  let menuName: string = '';
  switch (args.contextSystem) {
    //
    case CONTEXT_SYSTEMS.FILE_BROWSER:
      menuName = Object.keys(CONTEXT_MENU_FILE_BROWSER)[args.contextMenuID];
      const menuFileBrowser: CONTEXT_MENU_FILE_BROWSER = Object.keys(
        CONTEXT_MENU_FILE_BROWSER,
      ).indexOf(menuName);
      onContextMenuClickFileBrowser({
        menuID: menuFileBrowser,
        rowID: args.rowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.SEARCH_CATALOG_FORM:
      menuName = Object.keys(CONTEXT_MENU_SEARCH_CATALOG_FORM)[args.contextMenuID];
      const menuSearchCatalogForm: CONTEXT_MENU_SEARCH_CATALOG_FORM = Object.keys(
        CONTEXT_MENU_SEARCH_CATALOG_FORM,
      ).indexOf(menuName);
      onContextMenuClickSearchCatalogForm({
        menuID: menuSearchCatalogForm,
        rowID: args.rowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.SEARCH_CATALOG_SELECTED_ITEMS:
      menuName = Object.keys(CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS)[
        args.contextMenuID
      ];
      const menuSearchSelectedItems: CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS =
        Object.keys(CONTEXT_MENU_SEARCH_CATALOG_SELECTED_ITEMS).indexOf(menuName);
      onContextMenuClickSelectedItems({
        menuID: menuSearchSelectedItems,
        rowID: args.rowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.PROJECT_DATA_FILES:
      menuName = Object.keys(CONTEXT_MENU_DATA_STAGING)[args.contextMenuID];
      const menuProjectDataFiles: CONTEXT_MENU_DATA_STAGING = Object.keys(
        CONTEXT_MENU_DATA_STAGING,
      ).indexOf(menuName);
      onContextMenuClickProjectDataFiles({
        menuID: menuProjectDataFiles,
        rowID: args.rowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.SEARCH_CATALOG_FORM_CAOM:
      menuName = Object.keys(CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM)[args.contextMenuID];
      const menuSearchCatalogFormCAOM: CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM =
        Object.keys(CONTEXT_MENU_SEARCH_CATALOG_FORM_CAOM).indexOf(menuName);
      onContextMenuClickSearchCatalogFormCAOM({
        menuID: menuSearchCatalogFormCAOM,
        rowID: args.rowID,
      });
      break;
    //
    case CONTEXT_SYSTEMS.FILE_BROWSER_STAGING:
      menuName = Object.keys(CONTEXT_MENU_FILE_BROWSER_STAGING)[args.contextMenuID];
      const menuFileBrowserDataFiles: CONTEXT_MENU_FILE_BROWSER_STAGING = Object.keys(
        CONTEXT_MENU_FILE_BROWSER_STAGING,
      ).indexOf(menuName);
      onContextMenuClickFileBrowserDataFiles({
        menuID: menuFileBrowserDataFiles,
        rowID: args.rowID,
      });
      break;
    //
  }
  //
} // ctx_onContextMenuClick

//  ------------------------------------------------------------
//
//  Open a sub menu in a context system.
//
//  ------------------------------------------------------------

export function ctx_openSubMenu(args: {
  contextSystem: CONTEXT_SYSTEMS;
  parentMenu: number;
  parentRowID: number;
}) {
  //
  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  const stateFetch: any = store.getState();
  const state: ContextMenuState = stateFetch.contextMenu;

  // context menus.
  const sContextVisible: boolean[][] = state.contextVisible;
  const sContextMenuDefinition: ContextMenuType[][] = state.contextMenuDefinition;

  const parentItem: ContextMenuItem =
    sContextMenuDefinition[args.contextSystem][args.parentMenu].items[args.parentRowID];

  // check if this context-menu item is enabled.
  if (parentItem.enabled === true && parentItem.childMenu > -1) {
    //
    // build the child menu definition.
    ctx_buildContextMenu({
      contextSystem: args.contextSystem,
      contextMenu: parentItem.childMenu,
      parentRowID: args.parentRowID,
    });

    // set the highlighted row for this menu, and clear the highlighted row for any other menus.
    var firstIndex = 0;
    if (args.parentMenu !== -1) {
      firstIndex = args.parentMenu + 1;
    }

    for (var i = firstIndex; i < NUM_CONTEXT_MENUS[args.contextSystem]; i++)
      store.dispatch(
        ctx_setContextRow({
          contextSystem: args.contextSystem,
          contextMenu: i,
          row: -1,
        }),
      );

    // close any open sub-menus.
    store.dispatch(
      ctx_setContextVisible({
        contextSystem: args.contextSystem,
        contextMenu: args.parentMenu,
        visible: true,
      }),
    );

    // calculate the position of the child menu, making sure it doesn't expand the container.
    ctx_calculatePosition({
      contextSystem: args.contextSystem,
      contextMenu: parentItem.childMenu,
      parentMenu: args.parentMenu,
      parentRowID: args.parentRowID,
    });

    // set the visibility of the child menu to true.
    store.dispatch(
      ctx_setContextVisible({
        contextSystem: args.contextSystem,
        contextMenu: parentItem.childMenu,
        visible: true,
      }),
    );
    //
  }
  //
} // ctx_openSubMenu

//  ------------------------------------------------------------
//
//  Handle a key press which may move the focus on a
//  context menu.
//
//  ------------------------------------------------------------

export function ctx_keyDownHandler(args: { key: string }) {
  //
  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  const stateFetch: any = store.getState();
  const state: ContextMenuState = stateFetch.contextMenu;

  // context menus.
  const sContextVisible: boolean[][] = state.contextVisible;
  const sContextRow: number[][] = state.contextRow;
  const sContextMenuDefinition: ContextMenuType[][] = state.contextMenuDefinition;

  let handled: boolean = false;

  // find a context system where at least one menu is displayed, and find the menu
  // that has the current focus.
  let contextSystem: number | undefined = undefined;
  let contextMenuWithFocus: number | undefined = undefined;
  let contextMenuVisible: number | undefined = undefined;
  for (
    let system: number = 0;
    system < Object.keys(CONTEXT_CONTAINERS).length - 1;
    system++
  ) {
    //
    // get the context system by finding a visible menu.
    for (let menu: number = 0; menu < NUM_CONTEXT_MENUS[system]; menu++) {
      if (sContextVisible[system][menu] === true) {
        contextSystem = system;
        contextMenuWithFocus = undefined;
        contextMenuVisible = menu;
      }
    }

    // get the highest menu that currently has focus.
    for (let menu: number = 0; menu < NUM_CONTEXT_MENUS[system]; menu++) {
      if (sContextVisible[system][menu] === true && sContextRow[system][menu] > -1) {
        contextMenuWithFocus = menu;
      }
    }
    //
  }

  // start off the first menu.
  let item: ContextMenuItem | undefined = undefined;
  let row: number = -1;
  if (
    contextSystem !== undefined &&
    contextMenuWithFocus === undefined &&
    (args.key === 'ArrowRight' || args.key === 'ArrowDown')
  ) {
    //
    // set the focus to the visible menu.
    contextMenuWithFocus = contextMenuVisible ?? 0;
    row = 0;
    item = sContextMenuDefinition[contextSystem][contextMenuWithFocus].items[row];

    store.dispatch(
      ctx_setContextRow({
        contextSystem: contextSystem,
        contextMenu: contextMenuWithFocus,
        row: row,
      }),
    );

    handled = true;
    //
  } else if (
    contextSystem !== undefined &&
    contextMenuWithFocus === undefined &&
    args.key === 'Escape'
  ) {
    // close the whole context system if escape is pressed.
    store.dispatch(
      ctx_setContextVisible({
        contextSystem: contextSystem,
        visible: false,
      }),
    );
    //
  } else if (contextSystem !== undefined && contextMenuWithFocus !== undefined) {
    //
    const definition: ContextMenuType =
      sContextMenuDefinition[contextSystem][contextMenuWithFocus];
    row = sContextRow[contextSystem][contextMenuWithFocus];

    // move down the current menu.
    if (args.key === 'ArrowDown') {
      //
      // check if we are at the bottom row.
      if (
        sContextRow[contextSystem][contextMenuWithFocus] <
        sContextMenuDefinition[contextSystem][contextMenuWithFocus].items.length - 1
      ) {
        row = row + 1;
        store.dispatch(
          ctx_setContextRow({
            contextSystem: contextSystem,
            contextMenu: contextMenuWithFocus,
            row: row,
          }),
        );
      }
      //
    }

    // move up the current menu.
    if (args.key === 'ArrowUp') {
      //
      // check if we are at the top row.
      if (sContextRow[contextSystem][contextMenuWithFocus] > 0) {
        row = row - 1;
        store.dispatch(
          ctx_setContextRow({
            contextSystem: contextSystem,
            contextMenu: contextMenuWithFocus,
            row: row,
          }),
        );
      }
      //
    }

    item = definition.items[row];

    // open up the next menu using the right arrow.
    if (args.key === 'ArrowRight') {
      //
      // build the child menu.
      ctx_openSubMenu({
        contextSystem: contextSystem,
        parentMenu: contextMenuWithFocus,
        parentRowID: row,
      });

      // set the initial row to the first one.
      store.dispatch(
        ctx_setContextRow({
          contextSystem: contextSystem,
          contextMenu: item.childMenu,
          row: 0,
        }),
      );
      //
    }

    // close the current menu using the left arrow.
    if (args.key === 'ArrowLeft') {
      //
      // set the selected row to none.
      store.dispatch(
        ctx_setContextRow({
          contextSystem: contextSystem,
          contextMenu: contextMenuWithFocus,
          row: -1,
        }),
      );

      // hide the menu with focus.
      store.dispatch(
        ctx_setContextVisible({
          contextSystem: contextSystem,
          contextMenu: contextMenuWithFocus, //definition.parentMenu,
          visible: false,
        }),
      );
      //
    }

    // close the whole context system if escape is pressed.
    if (args.key === 'Escape') {
      store.dispatch(
        ctx_setContextVisible({
          contextSystem: contextSystem,
          visible: false,
        }),
      );
    }

    // trigger an action if space is pressed.
    if (args.key === ' ' || args.key === 'Enter') {
      //
      // if the selected item is clickable then initiate the onClick event handler.
      if (item?.enabled === true && item.onClick === true) {
        //
        ctx_onContextMenuClick({
          contextSystem: contextSystem,
          contextMenuID: contextMenuWithFocus,
          rowID: sContextRow[contextSystem],
        });

        // hide the whole context system.
        store.dispatch(
          ctx_setContextVisible({
            contextSystem: contextSystem,
            visible: false,
          }),
        );
        //
      }
      //
    }

    handled = true;
    //
  }

  // return the handled flag.
  return handled;
  //
} // ctx_keyDownHandler

//  ------------------------------------------------------------
//
//  Checks if any menu from the given context system is
//  currently displayed.
//
//  ------------------------------------------------------------

export function ctx_menuDisplayed(args: { contextSystem: CONTEXT_SYSTEMS }) {
  //
  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  const stateFetch: any = store.getState();
  const state: ContextMenuState = stateFetch.contextMenu;

  // context menus.
  const sContextVisible: boolean[][] = state.contextVisible;

  return sContextVisible[args.contextSystem].indexOf(true) > -1;
  //
} // ctx_menuDisplayed
